import Linkify from 'linkify-react';
import * as React from 'react';
import styled from 'styled-components';
import t from '../../shared/translations';

interface IProps {
    message: {
        id: string;
        senderName: string;
        subject: string;
        content: string;
    } | null;
}

const Row = styled.div`
    display: grid;
    grid-template-columns: auto auto auto 1fr;
    gap: 0.25rem 1rem;
    border-top: 1px solid DarkGray;
    border-bottom: 1px solid DarkGray;
    padding: 0.3rem 0;
    margin-bottom: 0.3rem;
`;

const SmallContent = styled.div`
    color: grey;
    white-space: nowrap;
    overflow: hidden;
`;

const Content = styled.div`
    grid-column: 1/-1;
`;

function PrevMessage({ message }: IProps): JSX.Element {
    const [open, setOpen] = React.useState(false);
    if (!message) {
        return null;
    }

    const toggle = () => {
        setOpen(o => !o);
    };

    return <Row>
        <strong onClick={toggle}>{t('player.messages.label-prev-message')}</strong>
        <div onClick={toggle}>{message.senderName}</div>
        <div onClick={toggle}>{message.subject}</div>
        {open
            ? <Content>
                <Linkify options={{ nl2br: true }} tagName='div'>{message.content}</Linkify>
            </Content>
            : <SmallContent onClick={toggle}>
                {message.content}
            </SmallContent>}
    </Row>;
}

export default PrevMessage;
